import React from 'react';
import { coaches } from '../data/coaches';

/**
 * The product has no buyers yet, so there is no rating to show.
 * Once real reviews exist, add the star row and the real average/count back.
 */
export function RatingProof() {
  const faces = coaches.slice(0, 5);
  return <div className="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:gap-3 sm:text-left" data-id="element-270" data-mp="3ghajvnlcp69x">
      <div className="flex shrink-0 -space-x-2.5" data-id="element-271" data-mp="3lgdm709y4ye7">
        {faces.map(coach => <img key={coach.name} src={coach.avatar} alt="" width={36} height={36} className="h-9 w-9 rounded-full object-cover ring-2 ring-cream" data-id="element-272" data-mp="3liq1t6s8ewo3" />)}
      </div>
      <div className="leading-tight" data-id="element-273" data-mp="39pldmlxixec">
        <p className="text-[14px] font-semibold text-ink" data-id="element-274" data-mp="38o6f71slqrc">
          Built for mixed groups, ages 5–11
        </p>
        <p className="mt-1 text-[13px] text-ink-soft" data-id="element-275" data-mp="25240kdx39nr2">
          US · UK · Canada · Australia
        </p>
      </div>
    </div>;
}